import React, { useState } from "react";
import { IconButton } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import { useDataLayerValue } from "../../data-layer";
import "./searchpad.css";
function SearchPad({ back = false, toggle, value }) {
  const history = useHistory();

  const [, dispatch] = useDataLayerValue();
  const [search, setSearch] = useState({
    query: "" || sessionStorage.getItem("query"),
  });
  const handleSearch = (e) => {
    e.preventDefault();
    dispatch({
      type: "SET_TERM",
      term: search.query,
    });
    sessionStorage.setItem("query", search.query);
    history.push(`/search/${encodeURIComponent(search.query)}`);
  };

  return (
    <div className="searchPad">
      {back && (
        <IconButton onClick={() => toggle(!value)}>
          <ArrowBackIosIcon />
        </IconButton>
      )}
      <form className="search__searchBox">
        <input
          value={search.query}
          onChange={(e) => {
            setSearch({ query: e.target.value });
          }}
          type="text"
          placeholder="Search"
        />
        <button onClick={handleSearch} type="submit">
          <SearchIcon fontSize="small" />
        </button>
      </form>
    </div>
  );
}

export default SearchPad;
